import React from 'react';

const dbs = [
  {
    title: "Qdrant Vector Database",
    desc: "Qdrant is an open-source, high-performance vector database ideal for teams migrating vector embeddings for scalable AI workloads, advanced filtering, and self-hosted deployments."
  },
  {
    title: "ChromaDB Vector Store",
    desc: "ChromaDB is a lightweight and developer-friendly vector store designed for AI prototyping, local development, and smooth vector database migration in LangChain-based applications."
  },
  {
    title: "Weaviate Vector Database",
    desc: "Weaviate is a modular vector database supporting semantic search, hybrid search, and GraphQL APIs, making it a strong choice when migrating vector data across environments."
  },
  {
    title: "Milvus Vector Database",
    desc: "Milvus is a highly scalable open-source vector database built for production-grade AI systems, supporting billion-scale vector search, distributed deployments, and efficient vector database migration."
  },
  {
    title: "MongoDB Atlas Vector Search",
    desc: "MongoDB Atlas provides built-in vector search capabilities integrated with its document database, enabling seamless AI-powered semantic search, hybrid queries, and smooth migration of vector data within modern application stacks."
  },
  {
    title: "PGVector (PostgreSQL Vector Extension)",
    desc: "PGVector is a PostgreSQL extension that enables efficient storage and similarity search of vector embeddings directly inside PostgreSQL, supporting hybrid SQL + vector queries and smooth migration of vector workloads."
  }
];

function InfoCards() {
  return (
    <section
      className="py-16 px-6 bg-bg-soft"
      aria-labelledby="why-change-vector-database"
    >
      <h2
        id="why-change-vector-database"
        className="text-3xl text-center font-bold mb-4 text-text-primary"
      >
        Why Change Your Vector Database?
      </h2>

      <p className="text-center max-w-3xl mx-auto mb-12 text-text-secondary">
        As AI applications evolve, teams often need to migrate vector databases to
        improve performance, reduce costs, or adopt new features. Choosing the right
        vector database can significantly impact scalability, search accuracy, and
        long-term maintainability of AI systems.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-7 max-w-6xl mx-auto">
        {dbs.map((card, idx) => (
          <article
            key={idx}
            className="p-6 rounded-xl shadow-sm transition duration-300 bg-white border border-border hover:shadow-md"
            aria-label={`${card.title} reasons for vector database migration`}
          >
            <h3 className="text-xl font-semibold mb-3 text-text-primary">
              {card.title}
            </h3>
            <p className="text-base leading-relaxed text-text-secondary">
              {card.desc}
            </p>
          </article>
        ))}
      </div>
    </section>
  );
}

export default InfoCards;